import { CalendarOutlined, CheckSquareOutlined, ClockCircleOutlined, DownCircleOutlined, FileTextOutlined, MailOutlined, NumberOutlined, UploadOutlined } from "@ant-design/icons";
import { BsRecordCircle } from "react-icons/bs";
import { MdOutlineSort } from "react-icons/md";



export const getTypeIcon = (type) => {
  switch (type) {
    case 'text':
      return <MdOutlineSort />;
    case 'textarea':
      return <FileTextOutlined />;
    case 'radio':
      return <BsRecordCircle />;
    case 'checkbox':
      return <CheckSquareOutlined />;
    case 'select':
      return <DownCircleOutlined />;
    case 'file':
      return <UploadOutlined />;
    case 'date':
      return <CalendarOutlined />;
    case 'time':
      return <ClockCircleOutlined />;
    case 'email' : 
    return <MailOutlined />;
    case 'number':
      return <NumberOutlined />;
    default:
      return <BsRecordCircle />;
  }
};



export const getTypeLabel = (type) => {
  switch (type) {
    case 'text':
      return 'Réponse courte';
    case 'textarea':
      return 'Paragraphe';
    case 'radio':
      return 'Choix unique';
    case 'checkbox':
      return 'Cases à cocher';
    case 'select':
      return 'Liste déroulante';
    case 'file':
      return 'Importer un fichier';
    case 'date':
      return 'Date';
    case 'time':
      return 'Heure';
      case 'email':
      return 'Email';
      case 'number':
        return 'Nombre';
    default:
      return 'Choix unique';
  }
};